/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRedwoodTree = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m12 1.586 4.707 4.707-1.414 1.414L13 5.414v2.172l4.707 4.707-1.414 1.414L13 10.414v2.172l4.707 4.707-1.414 1.414L13 15.414V22h-2v-6.586l-3.293 3.293-1.414-1.414L11 12.586v-2.172l-3.293 3.293-1.414-1.414L11 7.586V5.414L8.707 7.707 7.293 6.293z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRedwoodTree as RedwoodTree };
